import {Component, OnDestroy, OnInit} from '@angular/core';
import {SearchComponent} from '../search/search.component';
import {UserBarComponent} from './user-bar/user-bar.component';
import {RouterLink} from '@angular/router';
import {FilterBarComponent} from './filter-bar/filter-bar.component';
import {ActionBarComponent} from './action-bar/action-bar.component';
import {TranslatePipe} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {NavStatusService} from '../nav-status.service';
import {NavigationPoint} from '../navigation-point';
import {NgClass} from '@angular/common';
import {UserStateService} from '../user/user.state.service';
import {User} from '../user/user';
import {HomeSearchComponent} from "./home-search/home-search.component";

@Component({
  selector: 'app-dam-header',
    imports: [
        SearchComponent,
        UserBarComponent,
        RouterLink,
        FilterBarComponent,
        ActionBarComponent,
        TranslatePipe,
        NgClass,
        HomeSearchComponent,
    ],
  templateUrl: './dam-header.component.html',
  styleUrl: './dam-header.component.scss'
})
export class DamHeaderComponent implements OnInit, OnDestroy {
    navSubscription: Subscription | undefined;
    activeNavPoint: NavigationPoint | undefined;
    user: User | null | undefined;
    userSubscription: Subscription | undefined;
    isIframeIntegrated: boolean = false;
    iframeIntegratedSubscription: Subscription | undefined;

    constructor(
        private navStatusService: NavStatusService,
        private userStateService: UserStateService,
    ) {
    }
    ngOnInit() {
        this.navSubscription = this.navStatusService.getActiveNavPoint().subscribe(res => {
            if (res) {
                this.activeNavPoint = res;
            }
        })
        this.userSubscription = this.userStateService.user$.subscribe(user => {
            this.user = user;
        });
        this.iframeIntegratedSubscription = this.navStatusService.getIframeIntegrated().subscribe(res => {
            this.isIframeIntegrated = res;
        })


    }

   /* openUpload() {
        this.uploadStateService.mode = 'new';
    }
    openSearch() {
        this.dialog.open(SearchComponent, {
            autoFocus: false
        });
    }*/
    ngOnDestroy(): void {
        if (this.navSubscription) {
            this.navSubscription.unsubscribe();
        }
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
        if (this.iframeIntegratedSubscription) {
            this.iframeIntegratedSubscription.unsubscribe();
        }
    }

    protected readonly NavigationPoint = NavigationPoint;
}
